.progress {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 0.25rem;
	width: 100%;
}

.track {
	width: 100%;
	max-width: 80px;
	height: 6px;
	min-height: 6px;
	background: var(--gray-100, #e6e6e6);
	border-radius: 9999px;
	overflow: hidden;
	border: 1px solid var(--gray-200, #e5e7eb);
	box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.02);
}

.fill {
	height: 100%;
	background: var(--primary, #4a90e2);
	width: 0%;
	transition: width 200ms ease;
}

.percent {
	font-weight: 600;
	font-size: 12px;
	color: var(--text, #111827);
	line-height: 1;
}
